<template>
    <TprmModal
        additional-class-name="SendTestEmailModal"
        :allow-close="!submitting"
        :open="open"
        :title="`Send a ${verificationType} Test Email`"
        subtitle="Test your email before sending to your entities."
        @close="$emit('close')"
    >
        <div class="SendTestEmailModal__emailLabel">
            Email Address
        </div>
        <div class="SendTestEmailModal__email">
            {{ userEmail }}
        </div>
        <template #footer>
            <NewButton
                :loading="submitting"
                :disabled="submitting"
                color="primary"
                @click="onSubmit"
            >
                Send Test
            </NewButton>
        </template>
    </TprmModal>
</template>
<script lang="ts">
    import { Component, Prop, Vue } from '@evidentid/vue-property-decorator';

    import startCase from 'lodash/startCase';

    import {
        VerificationRequestType,
    } from '@evidentid/tprm-portal-lib/models/notification-configuration/VerificationRequest.model';

    import NewButton from '@/components/new-button/NewButton.vue';
    import TprmModal from '@/components/tprm-modal/TprmModal.vue';
    import { useUserStore } from '@evidentid/dashboard-commons/modules/auth/store/user';

    // PRODUCT-26110 QA fixes4: declares every event this component `$emit`s -- without a
    // declared `emits`, Vue 3 warns "Component emitted event 'close'/'submit' but it is
    // neither declared in the emits option nor as an 'onClose'/'onSubmit' prop" every
    // time it fires.
    @Component({
        components: {
            NewButton,
            TprmModal,
        },
        emits: [ 'close', 'submit' ],
    })
    export default class SendTestEmailModal extends Vue {
        @Prop({ type: Boolean, default: false })
        private submitting!: boolean;

        @Prop({ type: Boolean, default: false })
        private open!: boolean;

        @Prop({ type: String })
        private type!: VerificationRequestType;

        private get verificationType(): string {
            return this.type === VerificationRequestType.nonCompliant
                ? 'Non-compliant'
                : startCase(this.type.toLowerCase());
        }

        private get userEmail(): string {
            return useUserStore().data?.email || '';
        }

        private onSubmit(): void {
            if (this.submitting) {
                return;
            }
            this.$emit('submit');
        }
    }
</script>
